import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=3b260c34"
import script from "./UsersView.vue?vue&type=script&lang=ts"
export * from "./UsersView.vue?vue&type=script&lang=ts"
import style0 from "./UsersView.vue?vue&type=style&index=0&id=3b260c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports